import React from 'react';




const HelpInfo = () => {
    return (
        <small className="form-text text-muted">Caso tenha alguma dificuldade, <a
            href="https://glpi.ufvjm.edu.br/Form/Render/61?token=bz7805mvDT5TcQTU2ZP3U245hQaK51VdAkH7yOXM"
            target="_blank" rel="noopener noreferrer">clique aqui</a> para abrir um chamado de suporte.
        </small>
    )
}

export {HelpInfo};